var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"ni-legend-item",class:( _obj = {}, _obj[("placement-" + _vm.placement)] = _vm.placement, _obj ),style:({
		'--x-shift': _vm.xShift,
	}),domProps:{"innerHTML":_vm._s(_vm.label)}})}
var staticRenderFns = []

export { render, staticRenderFns }